import { Button, ButtonProps } from '@arco-design/web-react';
import React from 'react';
import { IconPlus } from '@arco-design/web-react/icon';

export function ButtonCreate({ onClick, title = '新建', ...rest }: ButtonProps) {
  return (
    <Button icon={<IconPlus />} size="small" onClick={onClick} type="primary" {...rest}>
      {title}
    </Button>
  );
}
